import { SearchPage } from "@/pages/search/search-page";
import { RouteObject } from "react-router-dom";

const SearchRoute: RouteObject = {
    path: "search",
    element: <SearchPage />
};

export default SearchRoute;
